import api from "@/lib/axios";

const getErrorMessage = (error, fallback) =>
  error.response?.data?.message || error.message || fallback;

const buildCampaignPayload = (campaignData) => {
  const channel = campaignData.channel || "email";
  const includesEmail = channel === "email" || channel === "both";
  const includesSms = channel === "sms" || channel === "both";

  const payload = {
    name: campaignData.name?.trim(),
    channel,
    subject: includesEmail
      ? campaignData.subject?.trim() || campaignData.name?.trim() || ""
      : campaignData.name?.trim() || "",
    body: includesEmail
      ? (campaignData.body?.trim() ??
        campaignData.email_body?.trim() ??
        "")
      : "",
    sms_body: includesSms ? (campaignData.sms_body?.trim() ?? "") : "",
    candidate_ids: Array.isArray(campaignData.candidate_ids)
      ? campaignData.candidate_ids
      : [],
  };

  if (campaignData.template_id) {
    payload.template_id = campaignData.template_id;
  }

  return payload;
};

export const marketingCampaignsService = {
  getCampaigns: async (params = {}) => {
    try {
      const response = await api.get("/marketing/campaigns", { params });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to fetch campaigns"));
    }
  },

  getCampaign: async (campaignId) => {
    try {
      const response = await api.get(`/marketing/campaigns/${campaignId}`);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to fetch campaign"));
    }
  },

  createCampaign: async (campaignData) => {
    try {
      const response = await api.post(
        "/marketing/campaigns",
        buildCampaignPayload(campaignData),
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to create campaign"));
    }
  },

  updateCampaign: async (campaignId, campaignData) => {
    try {
      const response = await api.put(
        `/marketing/campaigns/${campaignId}`,
        buildCampaignPayload(campaignData),
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to update campaign"));
    }
  },

  deleteCampaign: async (campaignId) => {
    try {
      const response = await api.delete(`/marketing/campaigns/${campaignId}`);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to delete campaign"));
    }
  },
};
